import { type FC } from 'react';
import type { Animal } from '@/model/Animal.model';
import { ModalContainer } from '@/utils/modal';
import { RecordBulkObservationsProvider } from './RecordBulkObservationsProvider';
import { RecordBulkObservationsForm } from './RecordBulkObservationsForm';
import { type StudyApiId } from '@/model/Study.model.ts';

interface RecordBulkObservationsProps {
  animals: Array<Animal>;
  studyApiId: StudyApiId;
  closeModal: () => void;
  handleCallback: () => void;
}

const RecordBulkObservations: FC<RecordBulkObservationsProps> = ({
  animals,
  studyApiId,
  closeModal,
  handleCallback,
}) => {
  return (
    <RecordBulkObservationsProvider
      animals={animals}
      studyApiId={studyApiId}
      closeModal={closeModal}
      handleCallback={handleCallback}
    >
      <ModalContainer size="medium">
        <RecordBulkObservationsForm />
      </ModalContainer>
    </RecordBulkObservationsProvider>
  );
};

export default RecordBulkObservations;
